import React from "react";
import l from "components/util/l";
import PermissionGridField from "components/util/helpers/PermissionField";

const ProcessPermissionField = ({
  flowId,
  values,
  setFieldValue
}) =>
  <PermissionGridField
    flowId={flowId}
    fields={[
      {
        name: "permissions.show_view",
        label: l("Ver proceso%SA243"),
        dependancies: [
          "permissions.show_edit",
          "permissions.execute"
        ]
      },
      {
        name: "permissions.show_edit",
        label: l("Editar proceso%SA215"),
        parent: "permissions.show_view"
      },
      {
        name: "permissions.execute",
        label: l("Ejecutar proceso%SA219"),
        parent: "permissions.show_view"
      },
    ]}
    values={values}
    setFieldValue={setFieldValue}
  />

export default ProcessPermissionField;